// src/plugins/axios.js
import axios from 'axios'
import { getInstance } from './auth'
import store from './store/store'

const baseURL = process.env.VUE_APP_AXIOS_BASE_URL

// Create an axios instance
const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  },
})

api.interceptors.request.use(async (config) => {
  try {
    store.commit('IncActiveRequests')
  } catch (e) { /* store not ready */ }

  try {
    const auth = getInstance()
    const token = await auth.getTokenSilently()
    config.headers.Authorization = `Bearer ${token}`
  } catch (err) {
    console.warn('Auth0 silent token retrieval failed', err)
    // optional: redirect to login or handle gracefully
  }

  return config
}, (error) => {
  try { store.commit('DecActiveRequests') } catch (e) { /* noop */ }
  return Promise.reject(error)
})

api.interceptors.response.use((response) => {
  try { store.commit('DecActiveRequests') } catch (e) { /* noop */ }
  return response
}, (error) => {
  try { store.commit('DecActiveRequests') } catch (e) { /* noop */ }
  return Promise.reject(error)
})

export default api
